import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const newsApi = defineConnector({
  identifier: "newsApi",
  name: "NewsAPI",
  tagLine: "News headlines and article search",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://newsapi\\.org/.*",
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Register at [newsapi.org](https://newsapi.org/register) and copy the key from your account page.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://newsapi.org/v2/top-headlines?country=us",
  },
});
